// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.c-editor[data-v-b33a4398] {\n  width: 100%;\n}\n.c-count[data-v-b33a4398] {\n  text-align: right;\n  color: grey;\n  font-size: 0.75rem;\n  gap: 0.5rem;\n}\n.c-count.c-max[data-v-b33a4398] {\n  color: var(--v-warning-base);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
